import './src/main.css'
import BorderBox7 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox7.name, BorderBox7)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox7/index.js